<template>
  <div class="map-content">
    <div id="container"></div>
  </div>
</template>

<script>
import phoneIcon from "../../assets/images/phone.png";
import bikeIcon from "../../assets/images/bike.png";
import { mapState } from "vuex";
import remoteLoad from "@/assets/js/remoteLoad";
export default {
  data() {
    return {
      map: null,
      phonemarker: null,
      bikemarker: null,
    };
  },
  props: ["phoneAddr", "bikeAddr", "opeMap"],
  computed: {
    ...mapState(["regionList", "currentRegion"]),
  },
  mounted() {
    let regionList = this.regionList;

    if (regionList[this.currentRegion].id != "cn") {
      if (window.google) {
        this.initMap();
        // 未载入谷歌地图API，则先载入API再初始化
      } else {
        // 载入谷歌地图和UI组件
        Promise.all([
          remoteLoad(
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyByfqxMers4lp-sXvkU4P8dX4i6yQ3RZ84&libraries=visualization,places,geometry&language=en-us&region=EG"
          ),
        ]).then(() => {
          this.initMap();
        });
      }
    } else {
      if (window.AMap && window.AMapUI) {
        this.initMap();
        // 未载入高德地图API，则先载入API再初始化
      } else {
        // 载入高德地图和UI组件
        Promise.all([
          remoteLoad(
            "https://webapi.amap.com/maps?v=1.4.15&key=77faf27c291ef4d7a20bfb8d5f74b0b4&plugin=AMap.Riding"
          ),
        ]).then(() => {
          this.initMap();
        });
      }
    }
    // this.initMap();
  },
  watch: {
    opeMap: {
      handler(val) {
        let arr = this.regionList;
        let that = this;
        if (!val) {
          if (arr[this.currentRegion].id != "cn") {
            this.phonemarker.setMap(null);
            this.bikemarker.setMap(null);
          } else {
            this.map.remove(that.phonemarker);
            this.map.remove(that.bikemarker);
          }
        } else {
          if (arr[this.currentRegion].id != "cn") {
            this.setGoogleMarker();
          } else {
            this.setMap();
          }
        }
      },
    },
  },
  methods: {
    //初始化地图
    initMap() {
      let arr = this.regionList;
      if (arr[this.currentRegion].id != "cn") {
        this.initGoogleMap();
      } else {
        this.initCnMap();
      }
    },
    //谷歌地图
    initGoogleMap() {
      let that = this;
      this.map = new google.maps.Map(document.getElementById("container"), {
        mapId: "1dac188ecae44d48",
        zoom: 15,
        center: new google.maps.LatLng({
          lat: that.bikeAddr[1],
          lng: that.bikeAddr[0],
        }),
        disableDefaultUI: true,
      });
      this.setGoogleMarker();
    },
    //高德地图
    initCnMap() {
      let that = this;
      this.map = new AMap.Map("container", {
        mapStyle: "amap://styles/398469a1eaea0a930c1cb33226ee3080", //设置地图的显示样式
        center: new AMap.LngLat(that.bikeAddr[1], that.bikeAddr[0]),
        zoom: 13,
        viewMode: "3D",
      });
      this.setMap();
    },
    //google地图marker
    setGoogleMarker() {
      let that = this;
      if (this.phonemarker && this.bikemarker) {
        this.phonemarker.setMap(null);
        this.bikemarker.setMap(null);
      }
      this.phonemarker = new google.maps.Marker({
        position: new google.maps.LatLng({
          lat: that.phoneAddr[1],
          lng: that.phoneAddr[0],
        }),
        icon: phoneIcon,
      });
      this.bikemarker = new google.maps.Marker({
        position: new google.maps.LatLng({
          lat: that.bikeAddr[1],
          lng: that.bikeAddr[0],
        }),
        icon: bikeIcon,
      });
      this.phonemarker.setMap(this.map);
      this.bikemarker.setMap(this.map);
    },
    //设置高德点
    setMap() {
      let that = this;
      //  console.log(that.phoneAddr);
      //   console.log(that.bikeAddr);
      if (that.phonemarker) {
        this.map.remove(that.phonemarker);
      }
      if (that.bikemarker) {
        this.map.remove(that.bikemarker);
      }      
      // 创建一个 Marker 实例：
      this.phonemarker = new AMap.Marker({
        position: new AMap.LngLat(that.phoneAddr[1], that.phoneAddr[0]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        icon: phoneIcon,
        // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(-10, -30),
      });
      this.bikemarker = new AMap.Marker({
        position: new AMap.LngLat(that.bikeAddr[1], that.bikeAddr[0]), // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
        icon: bikeIcon,
        // 设置了 icon 以后，设置 icon 的偏移量，以 icon 的 [center bottom] 为原点
        offset: new AMap.Pixel(-10, -30),
      });

      // 将创建的点标记添加到已有的地图实例：
      this.map.add(that.phonemarker);
      this.map.add(that.bikemarker);
    },
  },
};
</script>

<style scoped>
.map-content {
  width: 100%;
  height: 100%;
}
#container {
  width: 100%;
  height: 100%;
}
.custom-input-card {
  width: 18rem;
}

.custom-input-card .btn:last-child {
  margin-left: 1rem;
}

.content-window-card {
  position: relative;
  width: 23rem;
  padding: 0.75rem 0 0 1.25rem;
  box-shadow: none;
  bottom: 0;
  left: 0;
}

.content-window-card p {
  height: 2rem;
}
</style>